module.exports = __webpack_public_path__ + "static/2_1_search-2_NL-9ca64601c2863ade95181684e73a2f02.svg";